import SignUpCTAButton from "@/src/recipes/components/RecipeHero/SignUpCTAButton";
import clsx from "clsx";

const MediaPanelCTAOverlay = () => {
  return (
    <div
      className={clsx("MediaPanel__imageOverlay", "absolute inset-0 md:hidden")}
    >
      <div
        className={clsx(
          "absolute inset-0 bg-gradient-to-b from-transparent to-zinc-800/50"
        )}
      />
      <div
        className={clsx(
          "absolute bottom-0 left-0 right-0 flex flex-col gap-y-1 p-6 2xs:gap-y-2"
        )}
      >
        <div
          className={clsx(
            "font-spatial text-xl font-extrabold text-white 2xs:text-2xl"
          )}
        >
          Unlock this recipe
        </div>
        <SignUpCTAButton componentLocation="media_panel_overlay_mobile" />
      </div>
    </div>
  );
};

export default MediaPanelCTAOverlay;
